<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="card-title mb-3 font-weight-bold">Internal Memo Detail - {{ detailInfo?.name }}</div>
        </div>
        <div class="card-body">
          <div class="row row row-cols-1 row-cols-md-2 row-cols-xl-3 gx-5 gy-3">
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-home"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Category</h4>
                  <small class="text-body-secondary"
                    ><span> {{ detailInfo?.im_category }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-credit-card"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Number</h4>
                  <small class="text-body-secondary"
                    ><span> {{ detailInfo?.im_number }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-calendar"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Year</h4>
                  <small class="text-body-secondary"
                    ><span> {{ detailInfo?.im_year }}</span>
                  </small>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-calendar"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Created At</h4>
                  <small class="text-body-secondary"
                    ><span> {{ createdAt }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-user"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Created By</h4>
                  <small class="text-body-secondary"
                    ><span> {{ createdBy }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-calendar"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Updated At</h4>
                  <small class="text-body-secondary"
                    ><span> {{ updatedAt }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-user"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Updated By</h4>
                  <small class="text-body-secondary"
                    ><span> {{ updatedBy }}</span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <div class="card-title mb-3 font-weight-bold">Value Detail</div>
        </div>
        <div class="card-body">
          <div class="row row row-cols-1 row-cols-md-2 row-cols-xl-3 gx-5 gy-3">
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-dollar-sign"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Used IM Values</h4>
                  <small class="text-body-secondary"
                    ><span> {{ formatedUsedValue }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-dollar-sign"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Remaining IM Values</h4>
                  <small class="text-body-secondary"
                    ><span> {{ formatedRemainingValue }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-dollar-sign"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Total IM Values</h4>
                  <small class="text-body-secondary"
                    ><span> {{ formatedImValue }}</span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header font-weight-bold">Internal Memo Files</div>
        <div class="card-body">
          <div v-for="(attachment, index) in detail?.attachments" :key="index">
            <span> {{ index == 0 ? 'Internal Memo' : `Lampiran ${index}` }}: </span>
            <a v-if="attachment?.url" :href="attachment?.url || ''" target="_blank">
              {{ attachment?.name ? attachment?.name : attachment?.filename }}
            </a>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header font-weight-bold">Budget Detail</div>
        <div class="card-body">
          <div class="row row row-cols-1 row-cols-md-2 row-cols-xl-3 gx-5 gy-3">
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-credit-card"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Budget Plan</h4>
                  <small class="text-body-secondary"
                    ><span> {{ detail?.im_budget?.taskDetail?.plan_title || '-' }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-credit-card"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">GL Type</h4>
                  <small class="text-body-secondary"
                    ><span> {{ detail?.im_budget?.taskDetail?.budget_type || '-' }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-credit-card"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Budget GL</h4>
                  <small class="text-body-secondary"
                    ><span> {{ `${detail?.im_budget?.taskDetail?.gl_code || ''} - ${detail?.im_budget?.taskDetail?.account_name || ''}` }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-credit-card"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Budget Task</h4>
                  <small class="text-body-secondary"
                    ><span> {{ detail?.im_budget?.taskDetail?.name || '-' }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-calendar"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Month</h4>
                  <small class="text-body-secondary"
                    ><span> {{ monthName }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-calendar"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Relocate Value</h4>
                  <small class="text-body-secondary"
                    ><span> {{ formatedImValue }}</span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import boolean from 'vue-good-table/src/components/types/boolean';
export default {
  name: 'DetailPK',
  props: { dataDetail: Object, loadData: boolean, oldData: Object },
  mounted() {
    if (this.loadData) {
      console.log('dataDetail: ', this.dataDetail);
      this.detail = this.dataDetail;
      this.detailInfo = this.oldData;
    }
  },
  computed: {
    detail() {
      return this.$store.getters['imNumber/detail'] || null;
    },
    createdAt() {
      return this.detailInfo?.created_at ? moment(this.detailInfo?.created_at).format('DD MMM YYYY HH:mm') : moment().format('DD MMM YYYY HH:mm');
    },
    updatedAt() {
      return this.detailInfo?.updated_at ? moment(this.detail?.updated_at).format('DD MMM YYYY HH:mm') : moment().format('DD MMM YYYY HH:mm');
    },
    createdBy() {
      return this.detail?.created_by_user?.fullname || 'System';
    },
    updatedBy() {
      return this.detail?.updated_by_user?.fullname || 'System';
    },
    usedValue() {
      return this.detail?.budget_actuals?.reduce((acc, item) => acc + BigInt(item.po_value), BigInt(0));
    },
    remainingValue() {
      const imValue = BigInt(this.detail?.relocate_value || 0);
      const used = BigInt(this.usedValue || 0);
      return imValue - used;
    },
    formatedUsedValue() {
      return `Rp. ${this.convertNumber(this.usedValue)}`;
    },
    formatedRemainingValue() {
      return `Rp. ${this.convertNumber(this.remainingValue)}`;
    },
    formatedImValue() {
      return `Rp. ${this.convertNumber(this.detail?.relocate_value)}`;
    },
    monthName() {
      switch (this.detail?.im_budget?.month) {
        case 'jan':
          return 'January';
        case 'feb':
          return 'February';
        case 'mar':
          return 'March';
        case 'apr':
          return 'April';
        case 'may':
          return 'May';
        case 'jun':
          return 'June';
        case 'jul':
          return 'July';
        case 'aug':
          return 'August';
        case 'sep':
          return 'September';
        case 'oct':
          return 'October';
        case 'nov':
          return 'November';
        case 'dec':
          return 'December';
        default:
          return '-';
      }
    },
  },
  data() {
    return {
      detail: [],
      detailInfo: [],
    };
  },
  methods: {
    async onModalShow() {
      await this.$store.dispatch('imNumber/GET_DETAIL', this.id);
    },
    convertNumber(dat) {
      if (dat) {
        return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.notification-content {
  /* Add your styling for the notification content here */
}
</style>
